module.exports = __webpack_public_path__ + "static/media/2DGACM3.029d148a.jpg";